import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ced26d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Karte > Anmerkungen des Gutachters", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Anmerkungen auf der Karte", -1))
const _hoisted_5 = { class: "content h-full max-h-full" }
const _hoisted_6 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_7 = { class: "ml-2 text-xs" }
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = { class: "text-xs md:text-xs ml-2" }
const _hoisted_10 = { class: "text-xs text-gray-500" }
const _hoisted_11 = {
  key: 1,
  class: "justify-center items-center col-span-5 mt-1",
  style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)\n                rgb(235, 239, 240)","border-radius":"5px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, "Keine Anmerkungen aufgenommen", -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_oneto_five_image_div = _resolveComponent("oneto-five-image-div")!
  const _component_be_footer = _resolveComponent("be-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAnmerkungenPages(_ctx.ba), (anmerkungPage, key) => {
    return (_openBlock(), _createBlock(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      key: key
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (anmerkungPage['anmerkungen'].length > 0 )
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(anmerkungPage['anmerkungen'].slice(1), (anmerkung, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        style: {"border-style":"solid","border-color":"var(--white100) var(--white100) var(--white100) rgb(216, 215, 26)","border-radius":"5px"},
                        class: "mt-2"
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createTextVNode(" Titel: "),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(anmerkung.title), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createTextVNode(" Anmerkung: "),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(anmerkung.anmerkung), 1)
                        ]),
                        _createVNode(_component_oneto_five_image_div, {
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          fragesPath: undefined,
                          lang: _ctx.lang,
                          imageObjects: anmerkung.bilder,
                          class: "ml-2 col-span-8"
                        }, null, 8, ["ba", "immobilie", "lang", "imageObjects"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 2
    }, 1032, ["pdf-key"]))
  }), 128))
}